// src/index.tsx.old.old.old
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Customization.scss';
import { App } from './App';
import { AppProvider } from './AppDataContext';
import { initializeWidgetConfig } from './utils/widgetConfigInit';



// Initialize the app with styles and config
const initializeApp = async ( ) => {

   const { contextValueOut } = await initializeWidgetConfig();

  contextValueOut.root.render(
    <AppProvider value={contextValueOut}>
      <App />
    </AppProvider>
  );
};
initializeApp();

